import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ToFrontIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 30">
      <g clipPath="url(#clip0_13_77)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.1282 1.46341H10.3333C9.5403 1.46341 8.89743 2.11861 8.89743 2.92683V19.0244C8.89743 19.8326 9.5403 20.4878 10.3333 20.4878H26.1282C26.9212 20.4878 27.5641 19.8326 27.5641 19.0244V2.92683C27.5641 2.11861 26.9212 1.46341 26.1282 1.46341ZM10.3333 0C8.74728 0 7.46153 1.31039 7.46153 2.92683V19.0244C7.46153 20.6408 8.74728 21.9512 10.3333 21.9512H26.1282C27.7142 21.9512 29 20.6408 29 19.0244V2.92683C29 1.31039 27.7142 0 26.1282 0H10.3333Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 7.13416V5.85367H2.4359V7.13416H1ZM1 12.2561V9.69513H2.4359V12.2561H1ZM1 17.3781V14.8171H2.4359V17.3781H1ZM1 22.5V19.939H2.4359V22.5H1ZM1 26.3415V25.061H2.4359V26.3415C2.4359 26.6405 2.49415 26.9237 2.59905 27.1815L1.27267 27.7421C1.09674 27.3097 1 26.8362 1 26.3415ZM4.58974 30C4.10433 30 3.6397 29.9014 3.21544 29.7221L3.76547 28.3703C4.01843 28.4772 4.29638 28.5366 4.58974 28.5366H6.1453V30H4.58974ZM12.3675 30H9.25641V28.5366H12.3675V30ZM18.5897 30H15.4786V28.5366H18.5897V30ZM23.2564 30H21.7009V28.5366H23.2564V30Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_13_77">
          <rect width="30" height="30" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default ToFrontIcon;
